<template>
  <stock-page-base
    back-route-name="Coupons"
    title-key="coupons.stockPageTitle"
    :fetch-stock="fetchStock"
    :fetch-products="fetchProducts"
  />
</template>

<script>
import Axios from '@/helpers/axios';
import StockPageBase from '@/components/StockPageBase.vue';

export default {
  name: 'CouponStock',
  components: {
    StockPageBase,
  },
  methods: {
    async fetchStock({
      filters,
      route,
      client,
      i18n,
    }) {
      const data = {
        ...route.query,
        p: client.phoneType,
        dtk: client.dtk,
        brand_id: route.params.brand,
        group: filters.city || '',
        store: filters.branch || '',
        coupon_name: filters.rewards || '',
        lang: i18n.locale,
      };

      const response = await Axios.post('/brand/getStockedCoupons', data);
      return response.data.data;
    },
    async fetchProducts({
      route,
      client,
      i18n,
    }) {
      const data = {
        ...route.query,
        p: client.phoneType,
        dtk: client.dtk,
        brand_id: route.params.brand,
        lang: i18n.locale,
      };

      const response = await Axios.post('/brand/getStockedCouponList', data);
      return response.data.data;
    },
  },
};
</script>
